
/**
 * Format daty wyswietlanej w filtrze oraz wysylany do api
 */
export const FILTER_DATE_FORMAT = "YYYY-MM-DD";